import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Open book — two pages curving down toward a centre spine, with
 *  faint horizontal text-line hints on each page. Distinct from the
 *  closed `IcnDoc` glyph: this one means "reading / library /
 *  literature" rather than "document file". */
export function IcnBookOpen(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="book-open">
      {/* Outline of the open spread */}
      <path d="M2 4 Q4 3 8 4 Q12 3 14 4 V12 Q12 11 8 12 Q4 11 2 12 Z" />
      {/* Spine */}
      <path d="M8 4 V12" />
      {/* Left page text hints */}
      <path d="M3.5 6.5 H6.5" />
      <path d="M3.5 8.5 H6.5" />
      {/* Right page text hints */}
      <path d="M9.5 6.5 H12.5" />
      <path d="M9.5 8.5 H12.5" />
    </Svg>
  );
}
